import styled from 'styled-components';

import BaseErrorTag from 'components/ErrorTag';

export const ErrorTag = styled(BaseErrorTag)`
  margin-bottom: 16px;
`;
